module.exports = __webpack_public_path__ + "static/paymentSuccess-a6dc46fc0564afb6c60cddbb412fe94b.png";